/* eslint-disable @typescript-eslint/no-explicit-any */
import { HttpStatus } from '@montugroup/apis-styleguide';
import { Logger } from '@montugroup/utilities';
const logger = new Logger('tsrestRetryFn');
const MAXIMUM_RETRIES = 3;
const RETRYABLE_STATUS_CODES = new Set([
    HttpStatus.REQUEST_TIMEOUT,
    HttpStatus.INTERNAL_SERVER_ERROR,
    HttpStatus.BAD_GATEWAY,
    HttpStatus.SERVICE_UNAVAILABLE,
    HttpStatus.GATEWAY_TIMEOUT,
]);
export const getRetryFn = ({ addPermissionError, keys, operationType, oldRetry, }) => (failureCount, error) => {
    const status = error?.status;
    if (status === HttpStatus.FORBIDDEN) {
        addPermissionError(keys);
        return false;
    }
    if (typeof oldRetry === 'function') {
        return oldRetry(failureCount, error);
    }
    if (typeof oldRetry === 'boolean') {
        return oldRetry;
    }
    // NOTE: undefined status means it was a client side network load failure so we allow retries for that case (only for queries)
    if (!RETRYABLE_STATUS_CODES.has(status) && !(operationType === 'query' && status === undefined)) {
        logger.warn(`Not retrying for response status: ${status}`, {
            keys,
            operationType,
            oldRetry,
            error,
            status,
            failureCount,
        }, error);
        return false;
    }
    if (typeof oldRetry === 'number') {
        return failureCount < oldRetry;
    }
    if (operationType === 'query') {
        return failureCount < MAXIMUM_RETRIES;
    }
    return false;
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicmV0cnkuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvYXBpL3V0aWxzL3JldHJ5LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLHVEQUF1RDtBQUN2RCxPQUFPLEVBQUUsVUFBVSxFQUFFLE1BQU0sNkJBQTZCLENBQUM7QUFDekQsT0FBTyxFQUFFLE1BQU0sRUFBRSxNQUFNLHVCQUF1QixDQUFDO0FBSS9DLE1BQU0sTUFBTSxHQUFHLElBQUksTUFBTSxDQUFDLGVBQWUsQ0FBQyxDQUFDO0FBQzNDLE1BQU0sZUFBZSxHQUFHLENBQUMsQ0FBQztBQUUxQixNQUFNLHNCQUFzQixHQUFHLElBQUksR0FBRyxDQUFDO0lBQ3JDLFVBQVUsQ0FBQyxlQUFlO0lBQzFCLFVBQVUsQ0FBQyxxQkFBcUI7SUFDaEMsVUFBVSxDQUFDLFdBQVc7SUFDdEIsVUFBVSxDQUFDLG1CQUFtQjtJQUM5QixVQUFVLENBQUMsZUFBZTtDQUMzQixDQUFDLENBQUM7QUFHSCxNQUFNLENBQUMsTUFBTSxVQUFVLEdBQ3JCLENBQUMsRUFDQyxrQkFBa0IsRUFDbEIsSUFBSSxFQUNKLGFBQWEsRUFDYixRQUFRLEdBTVQsRUFBRSxFQUFFLENBQ0wsQ0FBQyxZQUFvQixFQUFFLEtBQVUsRUFBRSxFQUFFO0lBQ25DLE1BQU0sTUFBTSxHQUFHLEtBQUssRUFBRSxNQUFNLENBQUM7SUFFN0IsSUFBSSxNQUFNLEtBQUssVUFBVSxDQUFDLFNBQVMsRUFBRSxDQUFDO1FBQ3BDLGtCQUFrQixDQUFDLElBQUksQ0FBQyxDQUFDO1FBQ3pCLE9BQU8sS0FBSyxDQUFDO0lBQ2YsQ0FBQztJQUVELElBQUksT0FBTyxRQUFRLEtBQUssVUFBVSxFQUFFLENBQUM7UUFDbkMsT0FBTyxRQUFRLENBQUMsWUFBWSxFQUFFLEtBQUssQ0FBQyxDQUFDO0lBQ3ZDLENBQUM7SUFFRCxJQUFJLE9BQU8sUUFBUSxLQUFLLFNBQVMsRUFBRSxDQUFDO1FBQ2xDLE9BQU8sUUFBUSxDQUFDO0lBQ2xCLENBQUM7SUFFRCw4SEFBOEg7SUFDOUgsSUFBSSxDQUFDLHNCQUFzQixDQUFDLEdBQUcsQ0FBQyxNQUFNLENBQUMsSUFBSSxDQUFDLENBQUMsYUFBYSxLQUFLLE9BQU8sSUFBSSxNQUFNLEtBQUssU0FBUyxDQUFDLEVBQUUsQ0FBQztRQUNoRyxNQUFNLENBQUMsSUFBSSxDQUNULHFDQUFxQyxNQUFNLEVBQUUsRUFDN0M7WUFDRSxJQUFJO1lBQ0osYUFBYTtZQUNiLFFBQVE7WUFDUixLQUFLO1lBQ0wsTUFBTTtZQUNOLFlBQVk7U0FDYixFQUNELEtBQUssQ0FDTixDQUFDO1FBRUYsT0FBTyxLQUFLLENBQUM7SUFDZixDQUFDO0lBRUQsSUFBSSxPQUFPLFFBQVEsS0FBSyxRQUFRLEVBQUUsQ0FBQztRQUNqQyxPQUFPLFlBQVksR0FBRyxRQUFRLENBQUM7SUFDakMsQ0FBQztJQUVELElBQUksYUFBYSxLQUFLLE9BQU8sRUFBRSxDQUFDO1FBQzlCLE9BQU8sWUFBWSxHQUFHLGVBQWUsQ0FBQztJQUN4QyxDQUFDO0lBRUQsT0FBTyxLQUFLLENBQUM7QUFDZixDQUFDLENBQUMifQ==